var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "inline" } },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "所属门店",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: { placeholder: "请选择门店" },
                                      on: { change: _vm.onStoreChange },
                                      model: {
                                        value: _vm.storeId,
                                        callback: function ($$v) {
                                          _vm.storeId = $$v
                                        },
                                        expression: "storeId",
                                      },
                                    },
                                    _vm._l(_vm.storeOptionList, function (s) {
                                      return _c(
                                        "a-select-option",
                                        { key: s.id, attrs: { value: s.id } },
                                        [_vm._v(_vm._s(s.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-tabs",
                {
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "a-tab-pane",
                    { key: "takeout", attrs: { tab: "外卖设置" } },
                    [
                      _c(
                        "a-form",
                        { staticClass: "setting-form" },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "营业时间",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                                required: "",
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.timeType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "timeType", $$v)
                                    },
                                    expression: "form.timeType",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("全天24小时营业"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("设置营业时间"),
                                  ]),
                                ],
                                1
                              ),
                              _vm.form.timeType === "2"
                                ? _c(
                                    "div",
                                    { staticClass: "time-rows" },
                                    [
                                      _vm._l(
                                        _vm.timeArr,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "time-row",
                                            },
                                            [
                                              _c("a-time-picker", {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  value: _vm.toMoment(
                                                    item.startTime
                                                  ),
                                                  format: "HH:mm",
                                                  "minute-step": 5,
                                                  "allow-clear": false,
                                                  placeholder: "选择时间",
                                                },
                                                on: {
                                                  change: (t, val) =>
                                                    _vm.onTimeChange(
                                                      item,
                                                      "startTime",
                                                      val
                                                    ),
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "time-sep" },
                                                [_vm._v("-")]
                                              ),
                                              item.ciri
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "time-ciri",
                                                    },
                                                    [_vm._v("次日")]
                                                  )
                                                : _vm._e(),
                                              _c("a-time-picker", {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  value: _vm.toMoment(
                                                    item.endTime
                                                  ),
                                                  format: "HH:mm",
                                                  "minute-step": 5,
                                                  "allow-clear": false,
                                                  placeholder: "选择时间",
                                                },
                                                on: {
                                                  change: (t, val) =>
                                                    _vm.onTimeChange(
                                                      item,
                                                      "endTime",
                                                      val
                                                    ),
                                                },
                                              }),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "time-del",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.delTimeInterval(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.timeArr.length < 3,
                                              expression: "timeArr.length < 3",
                                            },
                                          ],
                                          attrs: { type: "link", icon: "plus" },
                                          on: { click: _vm.addTimeInterval },
                                        },
                                        [_vm._v("添加营业时间")]
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "商家公告",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder: "请输入商家公告",
                                  rows: 3,
                                },
                                model: {
                                  value: _vm.form.notice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "notice", $$v)
                                  },
                                  expression: "form.notice",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "下单公告",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder: "请输入下单公告",
                                  rows: 3,
                                },
                                model: {
                                  value: _vm.form.orderNotice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "orderNotice", $$v)
                                  },
                                  expression: "form.orderNotice",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "下单幻灯片",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("j-image-upload", {
                                attrs: {
                                  bizPath: "material",
                                  text: "上传幻灯片",
                                  isMultiple: "",
                                },
                                model: {
                                  value: _vm.form.orderMedia,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "orderMedia", $$v)
                                  },
                                  expression: "form.orderMedia",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "配送支持",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                                required: "",
                              },
                            },
                            [
                              _c(
                                "a-checkbox-group",
                                {
                                  model: {
                                    value: _vm.form.distributionSupport,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "distributionSupport",
                                        $$v
                                      )
                                    },
                                    expression: "form.distributionSupport",
                                  },
                                },
                                [
                                  _c("a-checkbox", { attrs: { value: "1" } }, [
                                    _vm._v("外卖配送"),
                                  ]),
                                  _c("a-checkbox", { attrs: { value: "2" } }, [
                                    _vm._v("到店自提"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form.distributionSupport.indexOf("2") > -1
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "消费方式",
                                        labelCol: _vm.formLabelCol,
                                        wrapperCol: _vm.formWrapperCol,
                                        required: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.form.diningType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "diningType",
                                                $$v
                                              )
                                            },
                                            expression: "form.diningType",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-checkbox",
                                            { attrs: { value: "1" } },
                                            [_vm._v("店内就餐")]
                                          ),
                                          _c(
                                            "a-checkbox",
                                            { attrs: { value: "2" } },
                                            [_vm._v("打包带走")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "预留手机",
                                        labelCol: _vm.formLabelCol,
                                        wrapperCol: _vm.formWrapperCol,
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-group",
                                        {
                                          model: {
                                            value: _vm.form.reserveTelOpen,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "reserveTelOpen",
                                                $$v
                                              )
                                            },
                                            expression: "form.reserveTelOpen",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-radio",
                                            { attrs: { value: "1" } },
                                            [_vm._v("开启")]
                                          ),
                                          _c(
                                            "a-radio",
                                            { attrs: { value: "2" } },
                                            [_vm._v("关闭")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "自提地址",
                                        labelCol: _vm.formLabelCol,
                                        wrapperCol: _vm.formWrapperCol,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "addr-search-row" },
                                        [
                                          _c("a-input", {
                                            staticStyle: { width: "400px" },
                                            attrs: {
                                              placeholder:
                                                "请输入地址（回车或点搜索定位）",
                                            },
                                            on: {
                                              pressEnter: _vm.onAddressSearch,
                                            },
                                            model: {
                                              value: _vm.form.address,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "address",
                                                  $$v
                                                )
                                              },
                                              expression: "form.address",
                                            },
                                          }),
                                          _c(
                                            "a-button",
                                            {
                                              staticClass: "addr-search-btn",
                                              attrs: {
                                                type: "primary",
                                                icon: "search",
                                              },
                                              on: {
                                                click: _vm.onAddressSearch,
                                              },
                                            },
                                            [_vm._v("搜索")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c("map-location-panel", {
                                    ref: "mapPanel",
                                    attrs: {
                                      lat: _vm.form.lat,
                                      lng: _vm.form.lng,
                                      address: _vm.form.address,
                                    },
                                    on: { change: _vm.onMapChange },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "包装费",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.boxType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "boxType", $$v)
                                    },
                                    expression: "form.boxType",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("按商品收取"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("按单收取"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form.boxType === "1"
                            ? _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "每单收取",
                                    labelCol: _vm.formLabelCol,
                                    wrapperCol: _vm.formWrapperCol,
                                  },
                                },
                                [
                                  _c("a-input-number", {
                                    staticStyle: { width: "400px" },
                                    attrs: {
                                      min: 0,
                                      precision: 2,
                                      step: 1,
                                      placeholder: "请输入金额",
                                    },
                                    model: {
                                      value: _vm.form.boxMoney,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "boxMoney", $$v)
                                      },
                                      expression: "form.boxMoney",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "打印设置",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.printType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "printType", $$v)
                                    },
                                    expression: "form.printType",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("订单支付后打印小票"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("商家接单后打印小票"),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v("防止漏单，建议订单支付后自动打印小票"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "外卖码",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    ghost: "",
                                    size: "small",
                                  },
                                  on: { click: _vm.showTakeoutQrcode },
                                },
                                [_vm._v("查看二维码")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-footer" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", loading: _vm.saving },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSave("takeout")
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "advance", attrs: { tab: "预约单设置" } },
                    [
                      _c(
                        "a-form",
                        { staticClass: "setting-form" },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "预约单支持",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-checkbox-group",
                                {
                                  model: {
                                    value: _vm.form2.open,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form2, "open", $$v)
                                    },
                                    expression: "form2.open",
                                  },
                                },
                                [
                                  _c("a-checkbox", { attrs: { value: "1" } }, [
                                    _vm._v("外卖"),
                                  ]),
                                  _c("a-checkbox", { attrs: { value: "2" } }, [
                                    _vm._v("自提"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form2.open.length > 0
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "休息时间支持预定",
                                        labelCol: _vm.formLabelCol,
                                        wrapperCol: _vm.formWrapperCol,
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-group",
                                        {
                                          model: {
                                            value: _vm.form2.restOpen,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form2,
                                                "restOpen",
                                                $$v
                                              )
                                            },
                                            expression: "form2.restOpen",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-radio",
                                            { attrs: { value: "1" } },
                                            [_vm._v("开启")]
                                          ),
                                          _c(
                                            "a-radio",
                                            { attrs: { value: "2" } },
                                            [_vm._v("关闭")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "可提前预定天数",
                                        labelCol: _vm.formLabelCol,
                                        wrapperCol: _vm.formWrapperCol,
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          staticStyle: { width: "200px" },
                                          attrs: { placeholder: "请选择" },
                                          model: {
                                            value: _vm.form2.day,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form2, "day", $$v)
                                            },
                                            expression: "form2.day",
                                          },
                                        },
                                        _vm._l(_vm.dayOptions, function (opt) {
                                          return _c(
                                            "a-select-option",
                                            {
                                              key: opt.value,
                                              attrs: { value: opt.value },
                                            },
                                            [_vm._v(_vm._s(opt.label))]
                                          )
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "预定开始时间",
                                        labelCol: _vm.formLabelCol,
                                        wrapperCol: _vm.formWrapperCol,
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          staticStyle: { width: "200px" },
                                          attrs: { placeholder: "请选择" },
                                          model: {
                                            value: _vm.form2.startTime,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form2,
                                                "startTime",
                                                $$v
                                              )
                                            },
                                            expression: "form2.startTime",
                                          },
                                        },
                                        _vm._l(
                                          _vm.startDayOptions,
                                          function (opt) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: opt.value,
                                                attrs: { value: opt.value },
                                              },
                                              [_vm._v(_vm._s(opt.label))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "预订单提醒时间",
                                        labelCol: _vm.formLabelCol,
                                        wrapperCol: _vm.formWrapperCol,
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          staticStyle: { width: "200px" },
                                          attrs: { placeholder: "请选择" },
                                          model: {
                                            value: _vm.form2.remind,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form2, "remind", $$v)
                                            },
                                            expression: "form2.remind",
                                          },
                                        },
                                        _vm._l(
                                          _vm.remindOptions,
                                          function (opt) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: opt.value,
                                                attrs: { value: opt.value },
                                              },
                                              [_vm._v(_vm._s(opt.label))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "预订单间隔时间",
                                        labelCol: _vm.formLabelCol,
                                        wrapperCol: _vm.formWrapperCol,
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          staticStyle: { width: "200px" },
                                          attrs: { placeholder: "请选择" },
                                          model: {
                                            value: _vm.form2.interval,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form2,
                                                "interval",
                                                $$v
                                              )
                                            },
                                            expression: "form2.interval",
                                          },
                                        },
                                        _vm._l(
                                          _vm.intervalOptions,
                                          function (opt) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: opt.value,
                                                attrs: { value: opt.value },
                                              },
                                              [_vm._v(_vm._s(opt.label))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-footer" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", loading: _vm.saving },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSave("advance")
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "makeTime", attrs: { tab: "制作时间" } },
                    [
                      _c(
                        "a-form",
                        { staticClass: "setting-form" },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "制作时间",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form3.open,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form3, "open", $$v)
                                    },
                                    expression: "form3.open",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("开启"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("关闭"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "制作单位",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form3.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form3, "type", $$v)
                                    },
                                    expression: "form3.type",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("按单"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("按件"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form3.type === "2",
                                  expression: "form3.type === '2'",
                                },
                              ],
                              attrs: {
                                label: "选择单位",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "200px" },
                                  attrs: { placeholder: "请选择商品单位" },
                                  model: {
                                    value: _vm.form3.unit,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form3, "unit", $$v)
                                    },
                                    expression: "form3.unit",
                                  },
                                },
                                _vm._l(_vm.unitOptions, function (name) {
                                  return _c(
                                    "a-select-option",
                                    { key: name, attrs: { value: name } },
                                    [_vm._v(_vm._s(name))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "每（单/件）制作时间",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  min: 0,
                                  precision: 0,
                                  placeholder: "请输入单个商品制作时间",
                                },
                                model: {
                                  value: _vm.form3.time,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form3, "time", $$v)
                                  },
                                  expression: "form3.time",
                                },
                              }),
                              _c("span", { staticClass: "unit-text" }, [
                                _vm._v("分钟"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-footer" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", loading: _vm.saving },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSave("makeTime")
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "delivery", attrs: { tab: "配送费设置" } },
                    [
                      _c(
                        "a-form",
                        { staticClass: "setting-form" },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "配送费类型",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form4.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form4, "type", $$v)
                                    },
                                    expression: "form4.type",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("固定配送费"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("按距离"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "3" } }, [
                                    _vm._v("按区域"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form4.type === "1"
                            ? _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "固定配送费",
                                    labelCol: _vm.formLabelCol,
                                    wrapperCol: _vm.formWrapperCol,
                                  },
                                },
                                [
                                  _c("a-input-number", {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      min: 0,
                                      precision: 2,
                                      placeholder: "请输入固定配送费",
                                    },
                                    model: {
                                      value: _vm.form4.money,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form4, "money", $$v)
                                      },
                                      expression: "form4.money",
                                    },
                                  }),
                                  _c("span", { staticClass: "unit-text" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "起送价",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  min: 0,
                                  precision: 2,
                                  placeholder: "请输入起送价",
                                },
                                model: {
                                  value: _vm.form4.startMoney,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form4, "startMoney", $$v)
                                  },
                                  expression: "form4.startMoney",
                                },
                              }),
                              _c("span", { staticClass: "unit-text" }, [
                                _vm._v("元"),
                              ]),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v("订单金额达不到起送价不可下单"),
                              ]),
                            ],
                            1
                          ),
                          _vm.form4.type === "2"
                            ? _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "起步配送费",
                                    labelCol: _vm.formLabelCol,
                                    wrapperCol: _vm.formWrapperCol,
                                  },
                                },
                                [
                                  _c("a-input-number", {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      min: 0,
                                      precision: 2,
                                      placeholder: "请输入起步配送费",
                                    },
                                    model: {
                                      value: _vm.form4.distanceStartMoney,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form4,
                                          "distanceStartMoney",
                                          $$v
                                        )
                                      },
                                      expression: "form4.distanceStartMoney",
                                    },
                                  }),
                                  _c("span", { staticClass: "unit-text" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.form4.type === "3"
                            ? _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "区域费用",
                                    labelCol: _vm.formLabelCol,
                                    wrapperCol: _vm.formWrapperCol,
                                  },
                                },
                                [
                                  _vm._l(
                                    _vm.form4.areaArr,
                                    function (area, index) {
                                      return _c(
                                        "div",
                                        { key: index, staticClass: "area-row" },
                                        [
                                          _c("a-input", {
                                            staticStyle: { width: "160px" },
                                            attrs: {
                                              placeholder: "请输入区域名称",
                                            },
                                            model: {
                                              value: area.name,
                                              callback: function ($$v) {
                                                _vm.$set(area, "name", $$v)
                                              },
                                              expression: "area.name",
                                            },
                                          }),
                                          _c("a-input-number", {
                                            staticStyle: {
                                              width: "120px",
                                              "margin-left": "10px",
                                            },
                                            attrs: {
                                              min: 0,
                                              precision: 2,
                                              placeholder: "起送价",
                                            },
                                            model: {
                                              value: area.startMoney,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  area,
                                                  "startMoney",
                                                  $$v
                                                )
                                              },
                                              expression: "area.startMoney",
                                            },
                                          }),
                                          _c("a-input-number", {
                                            staticStyle: {
                                              width: "120px",
                                              "margin-left": "10px",
                                            },
                                            attrs: {
                                              min: 0,
                                              precision: 2,
                                              placeholder: "配送费",
                                            },
                                            model: {
                                              value: area.money,
                                              callback: function ($$v) {
                                                _vm.$set(area, "money", $$v)
                                              },
                                              expression: "area.money",
                                            },
                                          }),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "time-del",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.delAreaRow(index)
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "link", icon: "plus" },
                                      on: { click: _vm.addAreaRow },
                                    },
                                    [_vm._v("添加区域")]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "配送范围",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  min: 0,
                                  precision: 1,
                                  placeholder: "请输入配送范围",
                                },
                                model: {
                                  value: _vm.form4.range,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form4, "range", $$v)
                                  },
                                  expression: "form4.range",
                                },
                              }),
                              _c("span", { staticClass: "unit-text" }, [
                                _vm._v("公里"),
                              ]),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v("顾客定位超出配送范围不可下单"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "配送方式",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form4.deliveryMode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form4, "deliveryMode", $$v)
                                    },
                                    expression: "form4.deliveryMode",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("商户自配送"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "10" } }, [
                                    _vm._v("到店自提"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-footer" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", loading: _vm.saving },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSave("delivery")
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: "二维码",
                    visible: _vm.qrVisible,
                    width: 480,
                    footer: null,
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.qrVisible = false
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "qr-wrap" },
                    [
                      _c("div", { staticClass: "qr-link-label" }, [
                        _vm._v(
                          "外卖码内容（占位链接，正式二维码待外卖码接口接入）"
                        ),
                      ]),
                      _c("div", { staticClass: "qr-link" }, [
                        _vm._v(_vm._s(_vm.qrPlaceholder)),
                      ]),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-top": "12px" },
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.copyQrLink },
                        },
                        [_vm._v("复制链接")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "field-tip",
                          staticStyle: { "margin-top": "12px" },
                        },
                        [_vm._v("顾客扫码进入小程序外卖点餐页")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }